import Vue from 'vue'
import TipsDialogComponent from './TipsDialog.vue'

// 创建 TipsDialog 构造器
const TipsDialogConstructor = Vue.extend(TipsDialogComponent)

let instance = null

const defaultOptions = {
  title: '温馨提示',
  message: '',
  headerImage: '',
  showCloseIcon: false,
  showCancelButton: true,
  showConfirmButton: true,
  cancelButtonText: '取消',
  confirmButtonText: '确认',
  closeOnClickOverlay: false,
  messageStyle: {
    textAlign: 'center',
  },
  cancelButtonStyle: {
  },
  confirmButtonStyle: {
  },
  decorationImage: '',
  decorationStyle: {
    top: '0',
    right: '0',
  },
}

/**
 * 显示提示弹窗
 * @param {Object} options 配置项
 * @param {String} options.title 标题
 * @param {String} options.message 内容文字
 * @param {Object} options.messageStyle 内容文字样式
 * @param {String} options.headerImage 头部背景图片
 * @param {Boolean} options.showCloseIcon 是否显示关闭图标
 * @param {Boolean} options.showCancelButton 是否显示取消按钮
 * @param {Boolean} options.showConfirmButton 是否显示确认按钮
 * @param {String} options.cancelButtonText 取消按钮文字
 * @param {String} options.confirmButtonText 确认按钮文字
 * @param {Object} options.cancelButtonStyle 取消按钮样式
 * @param {Object} options.confirmButtonStyle 确认按钮样式
 * @param {Boolean} options.closeOnClickOverlay 点击遮罩层是否关闭
 * @param {String} options.decorationImage 背景装饰图片（需使用require导入）
 * @param {Object} options.decorationStyle 背景装饰图片样式（位置、大小等）
 * @returns {Promise}
 */
function TipsDialog(options = {}) {
  return new Promise((resolve, reject) => {
    // 如果已有实例，先移除
    if (instance) {
      instance.$destroy()
      if (instance.$el && instance.$el.parentNode) {
        instance.$el.parentNode.removeChild(instance.$el)
      }
      instance = null
    }

    const mergedOptions = { ...defaultOptions, ...options }

    instance = new TipsDialogConstructor({
      propsData: {
        visible: true,
        ...mergedOptions
      }
    })

    // 监听事件
    instance.$on('confirm', () => {
      resolve('confirm')
      close()
    })

    instance.$on('cancel', () => {
      reject(new Error('cancel'))
      close()
    })

    instance.$on('close', () => {
      reject(new Error('close'))
      close()
    })

    // 挂载到 body
    instance.$mount()
    document.body.appendChild(instance.$el)
  })
}

function close() {
  if (instance) {
    instance.$destroy()
    if (instance.$el && instance.$el.parentNode) {
      instance.$el.parentNode.removeChild(instance.$el)
    }
    instance = null
  }
}

// 快捷方法：仅确认按钮
TipsDialog.alert = function(options = {}) {
  return TipsDialog({
    showCancelButton: false,
    showConfirmButton: true,
    showCloseIcon: false,
    ...options
  })
}
TipsDialog.alertErr = function(options = {}) {
  return TipsDialog({
    showCancelButton: true,
    showConfirmButton: false,
    showCloseIcon: false,
    ...options
  })
}

// 快捷方法：确认和取消按钮
TipsDialog.confirm = function(options = {}) {
  return TipsDialog({
    showCancelButton: true,
    showConfirmButton: true,
    ...options
  })
}

// 关闭弹窗
TipsDialog.close = close

// Vue 插件安装方法
TipsDialog.install = function(Vue) {
  Vue.component('TipsDialog', TipsDialogComponent)
  Vue.prototype.$tipsDialog = TipsDialog
}

// 导出组件
TipsDialog.Component = TipsDialogComponent

export default TipsDialog
export { TipsDialogComponent }



// WEBPACK FOOTER //
// ./src/components/TipsDialog/index.js